export const listConstants = {
    LIST_CAMPAGIN_DATA_REQUEST: "LIST_CAMPAGIN_DATA_REQUEST",
    LIST_CAMPAGIN_DATA_SUCCESS: "LIST_CAMPAGIN_DATA_SUCCESS",
    LIST_CAMPAGIN_DATA_FAILURE: "LIST_CAMPAGIN_DATA_FAILURE",
  
    // Toolbar
  
    LIST_EMAIL_INVITE_SUCCESS: "LIST_EMAIL_INVITE_SUCCESS",
    LIST_EMAIL_INVITE_FAILURE: "LIST_EMAIL_INVITE_FAILURE",
  
    LIST_RESUME_DOWNLOAD_SUCCESS: "LIST_RESUME_DOWNLOAD_SUCCESS",
    LIST_RESUME_DOWNLOAD_FAILURE: "LIST_RESUME_DOWNLOAD_FAILURE",
  
  
    LIST_CUSTOM_HEADERS_NAMES_SUCCESS:"LIST_CUSTOM_HEADERS_NAMES_SUCCESS",
    LIST_CUSTOM_HEADERS_NAMES_ERROR:"LIST_CUSTOM_HEADERS_NAMES_ERROR",
  
    LIST_CUSTOM_LIST_HEADERS_NAMES_SUCCESS:"LIST_CUSTOM_LIST_HEADERS_NAMES_SUCCESS",
    LIST_CUSTOM_LIST_HEADERS_NAMES_ERROR:"LIST_CUSTOM_LIST_HEADERS_NAMES_ERROR",
  
  
    LIST_CAMPAIGN_TAGS_SUCCESS:"LIST_CAMPAIGN_TAGS_SUCCESS",
    LIST_CAMPAIGN_TAGS_ERROR:"LIST_CAMPAIGN_TAGS_ERROR",
  
    LIST_CAMPAIGN_ADD_CUSTOM_TAG_SUCCESS:"LIST_CAMPAIGN_ADD_CUSTOM_TAG_SUCCESS",
    LIST_CAMPAIGN_ADD_CUSTOM_TAG_ERROR:"LIST_CAMPAIGN_ADD_CUSTOM_TAG_ERROR",
  
  
  
  };
  